import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Loading from "../../views/Loading";
import { Grid, Col, Row, Button, ControlLabel } from "react-bootstrap";
import moment from "moment";
import Card from "../Card/Card";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import { rutas } from "../../routes_backend/routes";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import { ExcelReporte } from "../../components/utils/Excel_produccion";
// import DatePicker from 'react-date-picker';
import { PDFReporte } from "../../components/utils/Pdf_produccion.js";




const myGrid = React.createRef();


export class genera_planilla extends Component {
  constructor(props) {
    super(props);
    
    this.state = { 

      // -------------- Centro Costo Inicial-------------
      is_IniCentroCosto : "209",
      dataIniCentroCosto: [
        { name: '209' },       

      ],
      // -------------- Centro Costo Final-------------
      is_FinCentroCosto : "209",
      dataFinCentroCosto: [
        { name: '209' },       

      ],
      // -------------- Planilla -------------
      is_Planilla : "",
      dataPlanilla: [
        { name: " " },
        { name: "1" },       
        { name: "2" },    
      ],
      // -------------- Periodo -------------
      is_Periodo : "2023",
      dataPeriodo: [
        { name: moment().format("YYYY"), },  
      ],
      // -------------- Mes -------------
      is_Mes : moment().format("M"),
      dataMes: [
        { name: moment().format("M") },       
         
      ],


      from_Date:"",
			to_Date: "",
      message: "",
      isLoading: false,
      source_grid: "",

    
      columns: [
        { text: "U_estado", datafield: "U_estado", width: 80, cellsalign: "center", },
        { text: "Mes", datafield: "Mes", width: 50, cellsalign: "center", },
        { text: "Año", datafield: "Año", width: 50, cellsalign: "center",  },
        { text: "U_CentroCosto", datafield: "U_CentroCosto", width: 100, cellsalign: "center",  },
        { text: "NombreCentro", datafield: "NombreCentro", width: 200, cellsalign: "center",  },
        { text: "U_Dscription", datafield: "U_Dscription", width: 200, cellsalign: "center",  },
        { text: "U_Codigo", datafield: "U_Codigo", width: 80, cellsalign: "center",  },
        { text: "DocEntry", datafield: "DocEntry", width: 80, cellsalign: "center",  },
        { text: "Name", datafield: "Name", width: 200, cellsalign: "center",  },
        { text: "U_Cuenta_Banco", datafield: "U_Cuenta_Banco", width: 80, cellsalign: "center",  cellsformat: "N", },
        { text: "Sueldo_Total", datafield: "Sueldo_Total", width: 100, cellsalign: "center",  cellsformat: "N", },
        { text: "Pago_Dia", datafield: "Pago_Dia", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Quincena", datafield: "Quincena", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Otros_Ingresos", datafield: "Otros_Ingresos", width: 100, cellsalign: "center",  cellsformat: "N", },
        { text: "Totales", datafield: "Totales", width: 100, cellsalign: "center",  cellsformat: "N", },
        { text: "Sueldo_Base", datafield: "Sueldo_Base", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Sueldo_Minimo", datafield: "Sueldo_Minimo", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Dias", datafield: "Dias", width: 100, cellsalign: "center",  },
        { text: "Sueldo_Devengado", datafield: "Sueldo_Devengado", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Bonificacion", datafield: "Bonificacion", width: 100, cellsalign: "center",  cellsformat: "N", },
        { text: "Adelanto_Quincena", datafield: "Adelanto_Quincena", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Adelanto_IGGS", datafield: "Adelanto_IGGS", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "IGGS", datafield: "IGGS", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "ISR", datafield: "ISR", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Otros_Descuentos", datafield: "Otros_Descuentos", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Liquido", datafield: "Liquido", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "DiasAusencia", datafield: "DiasAusencia", width: 100, cellsalign: "center",  },
        { text: "DiasIniLab", datafield: "DiasIniLab", width: 100, cellsalign: "center",  },
        { text: "DiasDesc", datafield: "DiasDesc", width: 100, cellsalign: "center",  },
        { text: "DiasDescuento", datafield: "DiasDescuento", width: 100, cellsalign: "center",  },
        { text: "Suspendido", datafield: "Suspendido", width: 100, cellsalign: "center",  },
        { text: "DiasSuspeIgss", datafield: "DiasSuspeIgss", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "U_Productivo", datafield: "U_Productivo", width: 100, cellsalign: "center",  },
        { text: "U_Planta", datafield: "U_Planta", width: 100, cellsalign: "center",  },
        { text: "Descuento_Produccion", datafield: "Descuento_Produccion", width: 100, cellsalign: "center", cellsformat: "N", },
        { text: "Descuento_Patio", datafield: "Descuento_Patio", width: 100, cellsalign: "center", cellsformat: "N", },
      ],
    };
  }
  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,

    });
  };
 
  onChangeFromDate(date) {
		this.setState({ from_Date: date });
	}
	onChangeToDate(date) {
		this.setState({ to_Date: date });
	}

  state = {
    selectedOption: '1',
    selectedMonth: 'Enero',
    selectedYear: '2023',
    date: new Date(),
    date2: new Date(),
    date3: new Date(),
    
  }
  handleDateChangeFrom = (e, date2) => {
    this.setState({ date2: e.target.value });
    const date_from_from = moment(e.target.value).format('YYYYMMDD');
    // const date_from = new Date(e.target.value).getDate();

    
    this.setState({
      from_fecha: date_from_from,
    });
  }
  // handleDateChangeYear = (e, date3) => {
  //   this.setState({ date3: e.target.value });
  //   const date_from_year = moment(e.target.value).format('YYYYMMDD');
  //   // const date_from_year = new Date(e.target.value).getDate();

    
  //   this.setState({
  //     from_year: date_from_year,
  //   });
  //   console.log(date_from_year);
  // }
  handleDateChange = (e, date) => {
    this.setState({ date: e.target.value });
    const date_to_to = moment(e.target.value).format('YYYYMMDD');
    const date_to = new Date(e.target.value).getDate();
 
    if (date_to < 16) {
      this.setState({ selectedOption: '1' });
    } else {
      this.setState({ selectedOption: '2' });
    }
    // const date_mes = moment(e.target.value).format('MM');
    const date_mes = new Date(e.target.value).getUTCMonth();
    if(date_mes === 0) {
      this.setState({ selectedMonth: 'Enero' });
    }else if(date_mes === 1) {
      this.setState({ selectedMonth: 'Febrero' });
    }else if(date_mes === 2) {
      this.setState({ selectedMonth: 'Marzo' });
    }else if(date_mes === 3) {
      this.setState({ selectedMonth: 'Abril' });
    }else if(date_mes === 4) {
      this.setState({ selectedMonth: 'Mayo' });
    }else if(date_mes === 5) {
      this.setState({ selectedMonth: 'Junio' });
    }else if(date_mes === 6) {
      this.setState({ selectedMonth: 'Julio' });
    }else if(date_mes === 7) {
      this.setState({ selectedMonth: 'Agosto' });
    }else if(date_mes === 8) {
      this.setState({ selectedMonth: 'Septiembre' });
    }else if(date_mes === 9) {
      this.setState({ selectedMonth: 'Octubre' });
    }else if(date_mes === 10) {
      this.setState({ selectedMonth: 'Noviembre' });
    }else if(date_mes === 11) {
      this.setState({ selectedMonth: 'Diciembre' });
    }

    // const date_from_year = moment(e.target.value).format('YYYY');
    // const date_from_year = new Date(e.target.value).getFullYear();
    const date_from_year = new Date(e.target.value).getUTCFullYear();

   
   
    this.setState({
      to_fecha: date_to_to,
      mes: date_mes,
      selectedYear: date_from_year,
    }
    );
    
    // console.log(this.date_from_year);
  }
  
  


  
  clear = () => {
    this.setState({
      message: "",
      isLoading: false,
      source_grid: "",
      date: new Date(),
			date2: new Date(),
      selectedOption : "",
      selectedMonth : "",
      selectedYear : "",

    });
  };
  send_print = (print) => {
    const { columns, source_grid } = this.state;
    let new_columns = [];
    let data_print = source_grid._source.localdata;
    let name = "Planilla";
    columns.forEach((element) => {
      let obj = {
        Header: element.text,
      };
      new_columns.push(obj);
    });
    ExcelReporte(data_print, new_columns, name);
  };
  data = () => {
    const {   from_fecha, to_fecha, is_IniCentroCosto, is_FinCentroCosto, } = this.state;
		// let from = moment(from_Date).format('YYYYMMDD');
		// let to = moment(to_Date).format('YYYYMMDD');




    // funcional
  //   let mesSelected = ''
  //   let anoSelected = ''
  //   if (from_fecha === undefined)  {
  //     return this.setState({
  //       message: "Selecione fecha inicial",
        
        
  //     });
  //   }
  //   else if (to_fecha === undefined) {
  //     return this.setState({
  //       message: "Selecione fecha final",
        
  //     });
  //   }
    
  // else if( mesSelected = moment(to_fecha).format('M') ) {
  //    if( anoSelected = moment(to_fecha).format('yyyy') ) {
  //     this.setState(   
  //       );
  //   }
  //   this.setState(       
  //     );
  // }

  let mesSelected = moment(to_fecha).format('M');
let anoSelected = moment(to_fecha).format('yyyy');

if (from_fecha === undefined) {
  return this.setState({
    message: "Seleccione fecha inicial",
  });
} else if (to_fecha === undefined) {
  return this.setState({
    message: "Seleccione fecha final",
  });
} else if (mesSelected === moment(to_fecha).format('M') && anoSelected === moment(to_fecha).format('yyyy')) {
  this.setState(
    // ...
  );
} else {
  this.setState(
    // ...
  );
}
  
    this.setState({
      isLoading: true,
    });
 

    // let url = `${rutas.get_GeneraPlanillaX}?Fecha_Ini=${from}&Fecha_Fin=${to}&CentroIni=${CentroCosto}&CentroFin=${CentroCosto}&Planilla=${planilla}&Periodo=${periodo}&Mes=${mes}`;
    // let url = `?Fecha_Ini=${from_fecha}&Fecha_Fin=${to_fecha}&CentroIni=${is_IniCentroCosto}&CentroFin=${is_FinCentroCosto}&Planilla=${this.state.selectedOption}&Periodo=${anoSelected}&Mes=${mesSelected}`;
    let url = `${rutas.get_GeneraPlanillaX}?Fecha_Ini=${from_fecha}&Fecha_Fin=${to_fecha}&CentroIni=${is_IniCentroCosto}&CentroFin=${is_FinCentroCosto}&Planilla=${this.state.selectedOption}&Periodo=${anoSelected}&Mes=${mesSelected}`;
    console.log(url);
    
    fetch(url)
      .then(async (res) => {
        let data = await res.json();
        const temp_res = Object.entries(data).length === 0; // true
        if (temp_res === true) {
          return this.setState({
            message: "no data",
            source_grid: "",
            isLoading: false,
          });
        }
        let array_source = [];
        data.forEach((element) => {
          let array = [
            element.U_estado,
            element.Mes,
            element.Año,
            element.U_CentroCosto,
            element.NombreCentro,
            element.U_Dscription,
            element.U_Codigo,
            element.DocEntry,
            element.Name,
            element.U_Cuenta_Banco,
            Intl.NumberFormat('en-US').format(element.Sueldo_Total.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Pago_Dia.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Quincena.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Otros_Ingresos.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Totales.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Sueldo_Base.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Sueldo_Minimo.toFixed(2)),
            element.Dias,
            Intl.NumberFormat('en-US').format(element.Sueldo_Devengado.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Bonificacion.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Adelanto_Quincena.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Adelanto_IGGS.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.IGGS.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.ISR.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Otros_Descuentos.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Liquido.toFixed(2)),
            element.DiasAusencia,
            element.DiasIniLab,
            element.DiasDesc,
            Intl.NumberFormat('en-US').format(element.DiasDescuento.toFixed(2)),
            element.Suspendido,
            Intl.NumberFormat('en-US').format(element.DiasSuspeIgss.toFixed(2)),
            element.U_Productivo,
            element.U_Planta,
            Intl.NumberFormat('en-US').format(element.Descuento_Produccion.toFixed(2)),
            Intl.NumberFormat('en-US').format(element.Descuento_Patio.toFixed(2)),
            
      
          ];
          array_source.push(array);
        });

        let temp_grid = {
          data: [],
          localdata: array_source,
          datafields: [
            
            { name: "U_estado", type: "string", map: "0" },
            { name: "Mes", type: "string", map: "1" },
            { name: "Año", type: "string", map: "2" },
            { name: "U_CentroCosto", type: "string", map: "3" },
            { name: "NombreCentro", type: "string", map: "4" },
            { name: "U_Dscription", type: "string", map: "5" },
            { name: "U_Codigo", type: "string", map: "6" },
            { name: "DocEntry", type: "number", map: "7" },
            { name: "Name", type: "string", map: "8" },
            { name: "U_Cuenta_Banco", type: "string", map: "9" },
            { name: "Sueldo_Total", type: "string", map: "10" },
            { name: "Pago_Dia", type: "string", map: "11" },
            { name: "Quincena", type: "string", map: "12" },
            { name: "Otros_Ingresos", type: "number", map: "13" }, 
            { name: "Totales", type: "number", map: "14" },            
            { name: "Sueldo_Base", type: "string", map: "15" },
            { name: "Sueldo_Minimo", type: "string", map: "16" },
            { name: "Dias", type: "number", map: "17" },
            { name: "Sueldo_Devengado", type: "string", map: "18" },
            { name: "Bonificacion", type: "string", map: "19" },
            { name: "Adelanto_Quincena", type: "string", map: "20" },
            { name: "Adelanto_IGGS", type: "string", map: "21" },
            { name: "IGGS", type: "string", map: "22" },
            { name: "ISR", type: "string", map: "23" },
            { name: "Otros_Descuentos", type: "string", map: "24" },
            { name: "Liquido", type: "string", map: "25" },
            { name: "DiasAusencia", type: "number", map: "26" },
            { name: "DiasIniLab", type: "number", map: "27" },
            { name: "DiasDesc", type: "string", map: "28" },
            { name: "DiasDescuento", type: "string", map: "29" },
            { name: "Suspendido", type: "string", map: "30" },
            { name: "DiasSuspeIgss", type: "string", map: "31" },
            { name: "U_Productivo", type: "string", map: "32" },
            { name: "U_Planta", type: "string", map: "33" },
            { name: "Descuento_Produccion", type: "string", map: "34" },
            { name: "Descuento_Patio", type: "string", map: "35" },


          ],
          datatype: "array",
        };
        this.setState({
          isLoading: false,
          source_grid: new jqx.dataAdapter(temp_grid),
          message: "",
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          message: "error in server",
        });
      });
  };
  render() {
    const { 
      is_IniCentroCosto,
      is_FinCentroCosto,
      // is_Periodo,
      // mes,
      dataIniCentroCosto, 
      dataFinCentroCosto,
      // dataPeriodo,
      // dataMes,
      // is_description, 
      message, 
      isLoading, 
      // from_year

      
    } = this.state;

    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="PLANILLA PRODUCCION"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div>
                      <div className="row">
                      <div className="col-sm-2">
												<ControlLabel>Del: </ControlLabel>
												<br />
                        <input type="date" style={inputStyle} value={this.state.date2} onChange={this.handleDateChangeFrom} />
												{/* <DatePicker 
													onChange={(from_Date) => this.onChangeFromDate(from_Date)}
													value={from_Date}
												/> */}
											</div>
											<div className="col-sm-2">
												<ControlLabel>Al: </ControlLabel>
												<br />
												<input type="date" style={inputStyle} value={this.state.date} onChange={this.handleDateChange} />
											</div>                                           
                       
                        {/* ----------- Centro Inicial ------------ */}
                        <div className="col-sm-2">
                          <label htmlFor="is_IniCentroCosto">
                            Centro de Costo Inicial
                          </label>
                          <select
                            disabled={true}
                            value={is_IniCentroCosto}
                            name="is_IniCentroCosto"
                            id="is_IniCentroCosto"
                            className="form-control"
                            onChange={this.onChange}
                          >
                            {dataIniCentroCosto &&
                              dataIniCentroCosto.map((res) => (
                                <option key={res.name} value={res.name}>
                                {res.name}
                              </option>
                              ))}
                          </select>
                        </div>

                        {/* ----------- Centro Final ------------ */}
                        <div className="col-sm-2">
                          <label htmlFor="is_FinCentroCosto">
                            Centro de Costo Final
                          </label>
                          <select 
                            disabled={true}
                            value={is_FinCentroCosto}
                            name="is_FinCentroCosto"
                            id="is_FinCentroCosto"
                            className="form-control"
                            onChange={this.onChange}
                          >
                            {dataFinCentroCosto &&
                              dataFinCentroCosto.map((res) => (
                                <option key={res.name} value={res.name}>
                                {res.name}
                              </option>
                              ))}
                          </select>
                        </div>
                         {/* ----------- Planilla ------------ */}
                         <div className="col-sm-1">
                          <label htmlFor="is_Planilla">
                            Planilla
                          </label>
                          <br />
                          <select style={inputStyle2}
                           value={this.state.selectedOption} disabled={true}
                          >
                             <option value=""></option>
                             <option value="1">1</option>
                             <option value="2">2</option>
                              
                          </select>
                          
                        </div>


                        {/* ----------- Periodo ------------ */}
                        <div className="col-sm-1">
                          <label htmlFor="is_Periodo">
                            Periodo
                          </label>
                          <br />

                          <select style={inputStyle2}
                           value={this.state.selectedYear} disabled={true}
                          >
                             <option value=""></option>
                             <option value="2020">2020</option>
                             <option value="2021">2021</option>
                             <option value="2022">2022</option>
                             <option value="2023">2023</option>
                             <option value="2024">2024</option>
                             <option value="2025">2025</option>
                              
                          </select>
                        </div>

                        {/* ----------- Mes ------------ */}
                        <div className="col-sm-1">
                          <label htmlFor="is_Mes">
                            Mes
                          </label>
                          <br />

                         <select style={inputStyle2}
                           value={this.state.selectedMonth } disabled={true}
                          //  {...console.log(mes)}
                          >
                             <option value=""></option>
                             <option value="Enero">1</option>
                             <option value="Febrero">2</option>
                             <option value="Marzo">3</option>
                             <option value="Abril">4</option>
                             <option value="Mayo">5</option>
                             <option value="Junio">6</option>
                             <option value="Julio">7</option>
                             <option value="Agosto">8</option>
                             <option value="Septiembre">9</option>
                             <option value="Octubre">10</option>
                             <option value="Noviembre">11</option>
                             <option value="Diciembre">12</option>                             
                              
                          </select>
                        </div>

                       

                        <div  className="col-sm-12">
                          <br />
                          <Button
                            onClick={this.data}
                            bsStyle="primary"
                            bsSize="small"
                            active
                          >
                            Generar
                          </Button>
                          &nbsp;
                          <Button
                            onClick={this.clear}
                            bsStyle="danger"
                            bsSize="small"
                            active
                          >
                            Limpiar
                          </Button>
                          <p style={style.errorMessage}>{message}</p>
                        </div>
                      </div>
                      <br />
                      
                      {!_.isEmpty(this.state.source_grid) ? (
                        <div className="row">
                          <p style={{ color: "red" }}>
                          </p>
                          <center>
                            <div>
                              <Button
                                onClick={() => this.send_print("pdf")}
                                bsStyle="primary"
                                active
                              >
                                <i className="pe-7s-print" />
                                Download Excel.
                              </Button>
                            </div>
                          </center>
                          <br />

                          <div className="col-sm-12">
                            <JqxGrid
                              ref={myGrid}
                              width={"100%"}
                              height={"800px"}
                              columns={this.state.columns}
                              source={this.state.source_grid}
                              //autoheight={true}
                              filterable={true}
                              selectionmode={"singlerow"}
                              showfilterrow={true}
                              altrows={true}
                              enabletooltips={true}
                              columnsresize={true}
                              showtoolbar={true}
                              sortable={true}
                              theme={"material"}
                              showstatusbar={true}
                              showaggregates={true}
                              groupable={true}

                            />
                            <br />
                            <br />
                          </div>
                         
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps, { PDFReporte })(
    genera_planilla
);
const style = {
  text: {
    textAlign: "center",
  },

  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
};
const inputStyle = {
  width: "200px",
  height: "40px",
  padding: "10px",
  fontSize: "16px",
  borderRadius: "5px"
};
const inputStyle2 = {
  width: "100px",
  height: "40px",
  padding: "10px",
  fontSize: "16px",
  borderRadius: "5px"
};
